import {
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Filler,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip
} from 'chart.js';
import { useEffect, useState } from 'react';
import { Bar, Line } from 'react-chartjs-2';
import { useNavigate, useParams } from 'react-router-dom';
import { reporteService } from '../services/api';
import '../styles/Dashboard.css';

// Registrar componentes de Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const Dashboard = () => {
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { codigo } = useParams();

  // Función para construir rutas con el código del tenant
  const getRoute = (path) => {
    return codigo ? `/${codigo}${path}` : path;
  };

  useEffect(() => {
    loadDashboard();
  }, []);

  const loadDashboard = async () => {
    try {
      setLoading(true);
      setError('');
      const response = await reporteService.getDashboard();
      console.log('Dashboard response:', response.data);
      console.log('Gastos fijos recordatorio:', response.data?.gastos_fijos_recordatorio);
      console.log('Tipo de gastos_fijos_recordatorio:', typeof response.data?.gastos_fijos_recordatorio);
      console.log('Es array?:', Array.isArray(response.data?.gastos_fijos_recordatorio));
      setDashboard(response.data);
    } catch (err) {
      console.error('Dashboard error:', err);
      console.error('Error response:', err.response?.data);

      // Manejar error de token inválido/expirado
      if (err.response?.status === 401 || err.response?.status === 422) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
        return;
      }

      const errorMessage = err.response?.data?.error || err.response?.data?.msg || 'Error al cargar el dashboard';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Cargando dashboard...</div>;
  if (error) return (
    <div className="error-container">
      <div className="error">{error}</div>
      <button onClick={loadDashboard} className="btn-retry">
        Reintentar
      </button>
    </div>
  );

  // Obtener información del tenant con mensaje del admin
  const tenantInfo = localStorage.getItem('tenant_info') ? JSON.parse(localStorage.getItem('tenant_info')) : null;

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1>Dashboard</h1>
        <div className="dashboard-date">
          {new Date().toLocaleDateString('es-DO', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
        </div>
      </div>

      {/* Mensaje del Super Admin */}
      {tenantInfo?.mensaje_admin && (
        <div className="mensaje-admin-container">
          <div className="mensaje-admin">
            <div className="mensaje-admin-header">
              <span className="mensaje-admin-icon">✉️</span>
              <strong>Mensaje del Administrador</strong>
              <span className="mensaje-admin-fecha">
                {new Date(tenantInfo.fecha_mensaje).toLocaleDateString()}
              </span>
            </div>
            <div className="mensaje-admin-content">
              {tenantInfo.mensaje_admin}
            </div>
          </div>
        </div>
      )}

      {dashboard && (
        <>
          {/* Tarjetas principales de métricas */}
          <div className="metrics-grid">
            <div className="metric-card blue" onClick={() => navigate(getRoute('/deben-pagar'))} style={{cursor: 'pointer'}}>
              <div className="metric-icon" style={{position: 'relative'}}>
                <div style={{
                  backgroundColor: '#5DADE2',
                  borderRadius: '8px',
                  padding: '0.5rem',
                  textAlign: 'center',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                  minWidth: '60px'
                }}>
                  <div style={{
                    fontSize: '0.7rem',
                    color: 'white',
                    backgroundColor: 'rgba(0,0,0,0.3)',
                    padding: '2px 4px',
                    borderRadius: '4px 4px 0 0',
                    marginBottom: '2px'
                  }}>
                    {new Date().toLocaleDateString('es-ES', { month: 'short' }).toUpperCase()}
                  </div>
                  <div style={{
                    fontSize: '1.8rem',
                    fontWeight: 'bold',
                    color: '#1E3A8A',
                    backgroundColor: 'white',
                    padding: '4px',
                    borderRadius: '0 0 4px 4px'
                  }}>
                    {new Date().getDate()}
                  </div>
                </div>
              </div>
              <div className="metric-content">
                <div className="metric-number">{dashboard.estadisticas.clientes_deben_pagar_hoy || 0}</div>
                <div className="metric-label">Deben Pagar Hoy</div>
                <div className="metric-action">
                  <button className="btn-more">Más información ➤</button>
                </div>
              </div>
            </div>

            <div className="metric-card green" onClick={() => navigate(getRoute('/prestamos-activos'))} style={{cursor: 'pointer'}}>
              <div className="metric-icon">✓</div>
              <div className="metric-content">
                <div className="metric-number">{dashboard.estadisticas.prestamos_activos}</div>
                <div className="metric-label">Préstamos Activos</div>
                <div className="metric-action">
                  <button className="btn-more">Más información ➤</button>
                </div>
              </div>
            </div>

            <div className="metric-card yellow" onClick={() => navigate(getRoute('/prestamos-atrasados'))} style={{cursor: 'pointer'}}>
              <div className="metric-icon">⚠</div>
              <div className="metric-content">
                <div className="metric-number">{dashboard.estadisticas.prestamos_atrasados || 0}</div>
                <div className="metric-label">Préstamos Atrasados</div>
                <div className="metric-action">
                  <button className="btn-more">Más información ➤</button>
                </div>
              </div>
            </div>

            <div className="metric-card red" onClick={() => navigate(getRoute('/prestamos-vencidos'))} style={{cursor: 'pointer'}}>
              <div className="metric-icon">📋</div>
              <div className="metric-content">
                <div className="metric-number">{dashboard.estadisticas.prestamos_vencidos || 0}</div>
                <div className="metric-label">Préstamos Vencidos</div>
                <div className="metric-action">
                  <button className="btn-more">Más información ➤</button>
                </div>
              </div>
            </div>

            {/* Recordatorio de Gastos Fijos - Cuadro Negro */}
            <div className="metric-card black gastos-fijos-card" onClick={() => navigate(getRoute('/finanzas'))} style={{cursor: 'pointer'}}>
              <div className="metric-icon">💰</div>
              <div className="metric-content">
                <div className="metric-number">{dashboard.gastos_fijos_recordatorio?.length || 0}</div>
                <div className="metric-label">Gastos Fijos</div>
                {dashboard.gastos_fijos_recordatorio && dashboard.gastos_fijos_recordatorio.length > 0 && (
                  <div className="metric-subtitle" style={{fontSize: '0.85rem', marginTop: '0.5rem', color: 'rgba(255,255,255,0.8)'}}>
                    {dashboard.gastos_fijos_recordatorio.length === 1 ? '1 recordatorio' : `${dashboard.gastos_fijos_recordatorio.length} recordatorios`}
                  </div>
                )}
                <div className="metric-action">
                  <button className="btn-more" style={{color: 'white', borderColor: 'rgba(255,255,255,0.3)'}}>Ver detalles ➤</button>
                </div>
              </div>
            </div>
          </div>

          {/* Segunda fila de métricas */}
          <div className="secondary-metrics">
            <div className="secondary-card" onClick={() => navigate(getRoute('/clientes/lista'))} style={{cursor: 'pointer'}}>
              <div className="secondary-icon">👥</div>
              <div className="secondary-content">
                <div className="secondary-number">{dashboard.estadisticas.total_clientes}</div>
                <div className="secondary-label">Clientes</div>
              </div>
            </div>

            <div className="secondary-card" onClick={() => navigate(getRoute('/cobros-hoy'))} style={{cursor: 'pointer'}}>
              <div className="secondary-icon">✅</div>
              <div className="secondary-content">
                <div className="secondary-number">
                  {dashboard.estadisticas.pagos_hoy || 0} de {dashboard.estadisticas.total_deben_pagar_hoy || 0}
                </div>
                <div className="secondary-label">Cobrados Hoy</div>
                <div style={{fontSize: '0.9rem', marginTop: '0.25rem', color: '#27ae60', fontWeight: 'bold'}}>
                  ${Math.round(dashboard.estadisticas.monto_cobrado_hoy || 0).toLocaleString('es-DO')}
                </div>
              </div>
            </div>

            <div className="secondary-card" onClick={() => navigate(getRoute('/por-recoger'))} style={{cursor: 'pointer'}}>
              <div className="secondary-icon">🔍</div>
              <div className="secondary-content">
                <div className="secondary-number">RD$ {Math.round(dashboard.estadisticas.monto_por_recoger || 0).toLocaleString('es-DO')}</div>
                <div className="secondary-label">Por Recoger</div>
              </div>
            </div>

            <div className="secondary-card" onClick={() => navigate(getRoute('/prestamos-atrasados'))} style={{cursor: 'pointer', borderLeft: '4px solid #e74c3c'}}>
              <div className="secondary-icon" style={{color: '#e74c3c'}}>⚠️</div>
              <div className="secondary-content">
                <div className="secondary-number" style={{color: '#e74c3c'}}>RD$ {Math.round(dashboard.estadisticas.monto_atrasado_por_recoger || 0).toLocaleString('es-DO')}</div>
                <div className="secondary-label">Atrasado Por Recoger</div>
              </div>
            </div>
          </div>

          {/* Sección Debe cobrar */}
          <div className="debt-collection-section">
            <h2>Debe cobrar hoy</h2>
            <div className="debt-bar">
              <div
                className="debt-progress"
                style={{
                  width: `${dashboard.estadisticas.porcentaje_cobranza_hoy || 0}%`
                }}
              ></div>
            </div>
            <div className="debt-amount">
              {dashboard.estadisticas.pagos_hoy || 0} de {dashboard.estadisticas.total_deben_pagar_hoy || 0} clientes han pagado
              <div style={{fontSize: '0.85rem', color: '#666', marginTop: '5px'}}>
                RD$ {Math.round(dashboard.estadisticas.monto_cobrado_hoy || 0).toLocaleString('es-DO')} de RD$ {Math.round(dashboard.estadisticas.monto_esperado_hoy || 0).toLocaleString('es-DO')} ({dashboard.estadisticas.porcentaje_cobranza_hoy || 0}%)
              </div>
            </div>
          </div>

          {/* Gráficos modernos con Chart.js */}
          <div className="charts-section">
            {/* Gráfico 1: Ingresos diarios - Línea animada */}
            <div className="chart-container">
              <div className="chart-header">
                <h3>Ingresos diarios</h3>
                <div className="chart-controls">
                  <button>─</button>
                  <button>✕</button>
                </div>
              </div>
              <div className="chart-content" style={{padding: '20px'}}>
                {dashboard.cobros_semana && dashboard.cobros_semana.length > 0 && (
                  <Line
                    data={{
                      labels: dashboard.cobros_semana.slice().reverse().map(dia => {
                        const fecha = new Date(dia.fecha);
                        return fecha.toLocaleDateString('es-DO', {day: '2-digit', month: '2-digit'});
                      }),
                      datasets: [{
                        label: 'Ingresos',
                        data: dashboard.cobros_semana.slice().reverse().map(dia => dia.monto),
                        borderColor: '#27ae60',
                        backgroundColor: 'rgba(39, 174, 96, 0.1)',
                        borderWidth: 3,
                        fill: true,
                        tension: 0.4,
                        pointRadius: 5,
                        pointBackgroundColor: '#27ae60',
                        pointBorderColor: '#fff',
                        pointBorderWidth: 2,
                        pointHoverRadius: 7
                      }]
                    }}
                    options={{
                      responsive: true,
                      maintainAspectRatio: false,
                      animation: {
                        duration: 1500,
                        easing: 'easeInOutQuart'
                      },
                      plugins: {
                        legend: {display: false},
                        tooltip: {
                          callbacks: {
                            label: (context) => `RD$ ${context.parsed.y.toFixed(2)}`
                          }
                        }
                      },
                      scales: {
                        y: {
                          beginAtZero: true,
                          ticks: {
                            callback: (value) => `$${value}`
                          }
                        }
                      }
                    }}
                    height={200}
                  />
                )}
              </div>
            </div>

            {/* Gráfico 2: Intereses por meses - Barras animadas */}
            <div className="chart-container">
              <div className="chart-header">
                <h3>Intereses por meses</h3>
                <div className="chart-controls">
                  <button>─</button>
                  <button>✕</button>
                </div>
              </div>
              <div className="chart-content" style={{padding: '20px'}}>
                <Bar
                  data={{
                    labels: ['Oct'],
                    datasets: [{
                      label: 'Intereses',
                      data: [dashboard.estadisticas.intereses_mes || 0],
                      backgroundColor: '#3498db',
                      borderColor: '#2980b9',
                      borderWidth: 2,
                      borderRadius: 8,
                      barThickness: 60
                    }]
                  }}
                  options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: {
                      duration: 1500,
                      easing: 'easeInOutBounce'
                    },
                    plugins: {
                      legend: {display: false},
                      tooltip: {
                        callbacks: {
                          label: (context) => `RD$ ${context.parsed.y.toFixed(2)}`
                        }
                      }
                    },
                    scales: {
                      y: {
                        beginAtZero: true,
                        ticks: {
                          callback: (value) => `$${value}`
                        }
                      }
                    }
                  }}
                  height={200}
                />
              </div>
            </div>

            {/* Gráfico 3: Ingresos del mes - Barras horizontales */}
            <div className="chart-container">
              <div className="chart-header">
                <h3>Ingresos del mes</h3>
                <div className="chart-controls">
                  <button>─</button>
                  <button>✕</button>
                </div>
              </div>
              <div className="chart-content" style={{padding: '20px'}}>
                <Bar
                  data={{
                    labels: ['Total Pagos', 'Pago Capital', 'Pago Intereses'],
                    datasets: [{
                      data: [
                        dashboard.estadisticas.monto_cobrado_mes || 0,
                        (dashboard.estadisticas.monto_cobrado_mes || 0) * 0.8,
                        dashboard.estadisticas.intereses_mes || 0
                      ],
                      backgroundColor: ['#3498db', '#f39c12', '#27ae60'],
                      borderColor: ['#2980b9', '#e67e22', '#229954'],
                      borderWidth: 2,
                      borderRadius: 8
                    }]
                  }}
                  options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: {
                      duration: 1500,
                      delay: (context) => context.dataIndex * 200
                    },
                    plugins: {
                      legend: {display: false},
                      tooltip: {
                        callbacks: {
                          label: (context) => `RD$ ${context.parsed.y.toFixed(2)}`
                        }
                      }
                    },
                    scales: {
                      y: {
                        beginAtZero: true,
                        ticks: {
                          callback: (value) => `$${value}`
                        }
                      }
                    }
                  }}
                  height={200}
                />
              </div>
            </div>
          </div>

          {/* Actividad Reciente - Pagos Recientes */}
          {dashboard.pagos_recientes && dashboard.pagos_recientes.length > 0 && (
            <div className="recent-payments-section">
              <h3>Actividad Reciente</h3>
              <div className="recent-payments-list">
                {dashboard.pagos_recientes.map((pago) => (
                  <div key={pago.id} className="payment-item">
                    <div className="payment-icon">💳</div>
                    <div className="payment-info">
                      <div className="payment-client">{pago.cliente_nombre}</div>
                      <div className="payment-amount">
                        RD$ {Math.round(pago.monto_total || 0).toLocaleString('es-DO')}
                      </div>
                    </div>
                    <div className="payment-date">
                      {new Date(pago.fecha_pago).toLocaleDateString('es-DO', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                      })}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Dashboard;